import { FilmIcon, PlayIcon } from '@heroicons/react/24/solid';
import { useEffect, useRef } from 'react';
import videojs from 'video.js';

export const ThumbnailVideo = ({ source, isSelected, setSelectedSource }) => {
  const player = useRef<videojs.Player | null>(null);

  const videoRef = useRef(null);
  useEffect(() => {
    if (source) {
      const options = {
        autoplay: !!source.thumbnail_stream_url,
        controls: false,
        responsive: true,
        muted: true,
        fluid: true,
        sources: [
          {
            src: source.thumbnail_stream_url ?? source.url,
            type: source.mime_type,
          },
        ],
      };

      if (!player.current) {
        const videoElement = videoRef.current;
        if (!videoElement) return;

        player.current = videojs(videoElement, options, () => {});
      } else {
        player.current.autoplay(options.autoplay);
        player.current?.src(options.sources);
      }
    }
  }, [videoRef, source]);

  return (
    <button
      className="thumbnail-button"
      onClick={(event) => {
        return setSelectedSource(event);
      }}
    >
      <div className="thumbnail-stream">
        {source.thumbnail_stream_url ? <div className="thumbnail-stream-dot" /> : <FilmIcon className="thumbnail-video-icon" />}
        <video ref={videoRef} className="video-js vjs-default-skin vjs-16-9 pointer-events-none" />
        {isSelected && (
          <div className="selected-source">
            <PlayIcon className="selected-source-play-icon" />
            <div>Now Playing</div>
          </div>
        )}
      </div>
    </button>
  );
};
